module.exports = __webpack_public_path__ + "img/plsblogo-modified.b3350579.png";